<template>
  <div>
    <BaseHeader
      :title="$t('ad-materials.header.title')"
      :style-variant="14"
    >
      <template #desc>
        <p>{{ $t('ad-materials.header.description') }}</p>
      </template>
      <template #content>
        <div class="d-flex flex-wrap ga-3 mx-4 mb-4 flex-column flex-md-row">
          <div class="d-flex flex-wrap flex-grow-1 ga-3">
            <v-btn
              variant="outlined"
              prepend-icon="mdi-filter-variant"
              color="primary"
              @click="handleFilterClick"
              density="compact"
              class="filter-btn"
            >
              {{ $t('ad-materials.button') }}
            </v-btn>
            <v-text-field
              v-model="searchQuery"
              prepend-inner-icon="mdi-magnify"
              :placeholder="$t('ad-materials.inputs.search.placeholder')"
              variant="outlined"
              density="compact"
              color="primary"
              class="search-field"
              hide-details
            />
          </div>

          <div class="right-controls">
            <v-select
              v-model="selectedSort"
              :items="sortOptions"
              :label="$t('ad-materials.inputs.sort.label')"
              item-title="text"
              item-value="value"
              variant="outlined"
              density="compact"
              color="primary"
              class="select-field"
              hide-details
            />
          </div>
        </div>
      </template>
    </BaseHeader>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import BaseHeader from '@/components/BaseHeader.vue'
// @ts-ignore
import { debounce } from '@/lib/debounce'

const { t } = useI18n()

const searchQuery = ref('')
const selectedSort = ref('new-to-old')

const sortOptions = [
  { value: 'new-to-old', text: t('ad-materials.inputs.sort.options.new-to-old') },
  { value: 'old-to-new', text: t('ad-materials.inputs.sort.options.old-to-new') },
]

const emit = defineEmits(['filter', 'filterButtonClick'])

const emitFilter = () => {
  emit('filter', {
    search: searchQuery.value,
    sort: selectedSort.value,
  })
}

const debouncedEmitFilter = debounce(emitFilter, 300)

const handleFilterClick = () => {
  emit('filterButtonClick')
  emitFilter()
}

watch([selectedSort], () => {
  emitFilter()
})

// Use debounced function only for searchQuery
watch(searchQuery, () => {
  debouncedEmitFilter()
})
</script>

<style scoped>
.right-controls {
  width: 210px;
}

.filter-btn {
  height: 40px;
  width: fit-content;
}

.search-field {
  max-width: 300px;
}

.select-field {
  max-width: 180px;
}

@media (max-width: 600px) {
  .controls-container {
    flex-direction: column;
  }
  .search-field {
    width: 100% !important;
    max-width: unset;
  }

  .select-field {
    width: 100% !important;
    max-width: unset;
  }
  .right-controls {
    width: 100%;
  }
}
</style>
